import React from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Avatar
} from "@mui/material";
import {
  Menu as MenuIcon,
  Email as EmailIcon,
  Notifications as NotificationsIcon,
  AccountCircle as AccountCircleIcon
} from "@mui/icons-material";
import PasteExcelIcon from "../components/PasteExcelIcon";

function MainAppBar({
  drawerWidth,
  handleDrawerToggle,
  isMobile,
  currentUser,
  handleAccountMenuClick,
  theme,
  onExcelDataImported // Tambahkan prop ini
}) {
  const handleDataImported = (data, headers, summary) => {
    console.log("Data diimport dari Excel:", {
      data,
      headers,
      summary
    });
    
    // Kirim data ke parent component
    if (onExcelDataImported) {
      onExcelDataImported(data, headers, summary);
    }

    // Atau lakukan apa yang Anda butuhkan dengan data:
    // - Simpan ke state global (Redux/Context)
    // - Kirim ke backend
    // - Tampilkan notifikasi
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        width: { sm: `calc(100% - ${drawerWidth}px)` },
        ml: { sm: `${drawerWidth}px` }
      }}
    >
      <Toolbar>
        <IconButton
          color="inherit"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ mr: 2, display: { sm: "none" } }}
        >
          <MenuIcon />
        </IconButton>

        <Box sx={{ flexGrow: 1 }} />

        {/* Tambahkan icon paste Excel di sini */}
        <PasteExcelIcon 
          onDataImported={handleDataImported}
          tooltipTitle="Paste data dari Excel"
        />

        <IconButton color="inherit"><EmailIcon /></IconButton>
        <IconButton color="inherit"><NotificationsIcon /></IconButton>
        <IconButton color="inherit" onClick={handleAccountMenuClick}>
          {currentUser ? (
            <Avatar
              src={currentUser.avatar}
              sx={{ width: 32, height: 32 }}
            >
              {currentUser.name ? currentUser.name.charAt(0).toUpperCase() : ''}
            </Avatar>
          ) : (
            <AccountCircleIcon />
          )}
        </IconButton>
      </Toolbar>
    </AppBar>
  );
}

export default MainAppBar;